import React, {useState, useEffect} from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {DeviceViewModel} from "../../../models/device.view-model";

export class MiniDrawerProps extends BaseProps {
  onOpenStateChange: Function;
  width: Number;
  device: DeviceViewModel;
  openFromLeft: Boolean;
  DrawerContent;
  drawerContentProps;
  children;
  delayMS: Number;
  className: String;
  drawerClassName: String;
}

export const MiniDrawer = ({
                             DrawerContent,
                             device,
                             className,
                             children,
                             onOpenStateChange,
                             delayMS = 200,
                             drawerClassName,
                             width,
                             openFromLeft,
                             drawerContentProps
                           }: MiniDrawerProps) => {
  if (device.isSmallView) {
    return <div className={['drawer-container', className].join(' ')}>{children}</div>;
  }

  const [open, setOpen] = useState(false);
  const [triggered, setTriggered] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId);
    }
  }, [open, triggered]);

  const onMouseEventHandle = (isOpen: Boolean) => {
    onOpenStateChange && onOpenStateChange(isOpen);
    setOpen(isOpen);
  }

  const onMouseOver = () => {
    clearTimeout(timeoutId);
    setTriggered(true);
    setTimeoutId(setTimeout(() => onMouseEventHandle(true), delayMS))
  }

  const onMouseLeave = () => {
    clearTimeout(timeoutId);
    onMouseEventHandle(false)
    setTimeoutId(setTimeout(() => setTriggered(false), delayMS))
  }

  const drawerContainer = {
    className: ['drawer-container', className].join(' '),
    onMouseOver,
    onMouseLeave
  }

  const drawerContent = {
    className: ['mini-drawer', open ? drawerClassName : ''].join(' '),
    style: {
      width: width,
      [device.isRtl ? (openFromLeft ? 'right' : 'left') : (openFromLeft ? 'left' : 'right')]: open ? 0 : -width,
    }
  }

  return (
    <div {...drawerContainer}>
      {children}
      <div {...drawerContent}>
        <DrawerContent {...drawerContentProps} />
      </div>
    </div>
  );
}
